import { Linkable } from '@/components/blocks/Linkable';
import { PRO_PATH } from '@/components/content/Header/constants';
import { proBoostSX } from '@/components/content/Header/styles/account/panel';
import DynamicIcon, { IconName } from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { toCamelCase } from '@/utils/toCamelCase';
import { Stack, Typography } from '@mui/material';
import { PRO_BOOST_BASE_URL } from 'shared/custom/constants/commonConstants';

export const ProBoostSection: React.FC = () => {
	const labels = useLocalization('HeaderAccountPanel');
	const PRO_BOOST_URL = `${PRO_BOOST_BASE_URL}/${PRO_PATH}`;

	return (
		<Linkable href={PRO_BOOST_URL} type="link" target="_blank" className="account-panel__pro-login">
			<Stack sx={proBoostSX.container}>
				<DynamicIcon
					name={toCamelCase(labels.ProBoost.Icon.t()) as IconName}
					aria-label="ProBoost"
					sx={{ color: 'grey.500' }}
				/>
				<Stack sx={proBoostSX.itemContainer}>
					<Typography variant="bodyBaseline" sx={proBoostSX.title}>
						{labels.ProBoost.Title.t()}
					</Typography>
					<Typography variant="bodySubText" sx={proBoostSX.message}>
						{labels.ProBoost.Msg.t()}
					</Typography>

					<Typography variant="bodySubText" sx={proBoostSX.link}>
						{labels.ProBoost.Link.t()}
					</Typography>
				</Stack>
			</Stack>
		</Linkable>
	);
};
